import { LeadForm } from '../../LeadForm'
import { makeLeadsPutRequest } from 'utils/api'
import { Button } from 'reactstrap'
import { useLoading } from 'hooks'
import { fromLead } from '../../serializers'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'
import { useDispatch } from 'react-redux'
import s from './LeadDetails.scss'

const Lead = ({ leadId, lead, setLead }) => {
  const reduxDispatch = useDispatch()

  const [, withLoadingLocks] = useLoading()

  const updateLead = async lead => {
    try {
      await withLoadingLocks(makeLeadsPutRequest(`/v1/leads/${leadId}`, fromLead(lead)))
      reduxDispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          title: 'Lead updated successfuly',
          level: 'success'
        }
      })
    } catch (e) {
      reduxDispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          title: 'An error occurred. Please contact support',
          level: 'error'
        }
      })
    }
  }

  const renderButton = () => (
    <Button
      className={s.saveBtn}
      onClick={() => {
        updateLead(lead)
      }}
      disabled={!lead.name}
    >
      Save
    </Button>
  )

  return (
    <>
      {renderButton()}
      <LeadForm lead={lead} setLead={setLead} />
      {renderButton()}
    </>
  )
}

export default Lead
